import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button } from "react-bootstrap";
import TODIS_FORM_ACQUIS_TRANS from "./form/GENERAL/acquistrans";
import TODIS_FORM_ACQUIS_LEGIS from "./form/GENERAL/acquislegis";
import "react-datepicker/dist/react-datepicker.css";
const TODIS_FORM_ACQUISRAIL = ({errors, touched, status, dataFromForm, requestId}) => {

    return (

        <Tabs defaultActiveKey="ACQUISLEGIS" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">

            <Tab eventKey="ACQUISLEGIS" title="EU ACQUIS" >
                <Container fluid>
                    <Row>
                        <TODIS_FORM_ACQUIS_LEGIS errors={errors} touched={touched} disabled={status} TypeForm="" dataFromForm={dataFromForm} requestId={requestId}/>
                    </Row>
                </Container>
            </Tab>

        </Tabs>
    )
}
export default TODIS_FORM_ACQUISRAIL;